import VanillaTilt from 'aos';
import Parallax from 'parallax-js';
document.querySelectorAll('[data-splitting-typing]').forEach((item) => {
  const chars = Splitting({ target: item, by: 'chars' })[0].chars;

  const totalChars = chars.length;
  const baseSpeed = 800;
  const speed = Math.max(35, baseSpeed / totalChars);

  chars.forEach((char, index) => {
    const randomDelay = Math.random() * 10;
    char.style.animationDelay = `${index * speed + randomDelay}ms`;
  });

  setTimeout(() => {
    item.classList.add('finished');
  }, totalChars * speed);
});

if (document.querySelector('[data-splitting-title]')) {
  const splittingArr = document.querySelectorAll('[data-splitting-title]');
  splittingArr.forEach((item, i) => {
    if (item.hasAttribute('data-splitting-char') === true) {
      const splitting = Splitting({
        target: item,
        by: 'chars',
      });
    } else {
      const splitting = Splitting({
        target: item,
        by: 'words',
      });
    }
  });
}


if (document.querySelector('[data-parallax-el]') && window.innerWidth >= 1025) {
  const parallaxContainer = document.querySelectorAll('[data-parallax-el]');
  parallaxContainer.forEach((elem) => {
    let parallaxInstance = new Parallax(elem);
    parallaxInstance.enable();
  });
}


Splitting();

window.initTilt = function initTilt() {
  if (document.querySelector('[data-tilt-init]') && window.innerWidth > 1024) {
    const tiltInitItemsArr = document.querySelectorAll('[data-tilt-init]');
    tiltInitItemsArr.forEach((item) => {
      VanillaTilt.init(item, {
        /*max: 7,*/
        max: 10,
        speed: 400,
        glare: true,
        "max-glare": 0.2,
        scale: 1.02,
      });
    });
  }
};

initTilt();